/**
 * 重量单位换算工具模块
 */

/**
 * 重量单位换算 - 将千克转换为指定单位
 * @param {number} weightInKg - 重量值（千克）
 * @param {string} unitName - 目标单位名称
 * @returns {string} - 换算后的重量（保留适当精度）
 */
export function convertWeightFromKg(weightInKg, unitName) {
    const weight = parseFloat(weightInKg) || 0;
    
    // 千克 - 不转换
    if (isKilogram(unitName)) {
        return weight.toFixed(3);
    }
    
    // 斤 - 千克转斤（1千克 = 2斤）
    if (isJin(unitName)) {
        return (weight * 2).toFixed(3);
    }
    
    // 克 - 千克转克（1千克 = 1000克）
    if (isGram(unitName)) {
        return (weight * 1000).toFixed(0);
    }
    
    // 两 - 千克转两（1千克 = 20两）
    if (isLiang(unitName)) {
        return (weight * 20).toFixed(2);
    }
    
    // 默认返回千克
    return weight.toFixed(3);
}

/**
 * 重量单位换算 - 将指定单位转换为千克
 * @param {number} weight - 重量值
 * @param {string} unitName - 当前单位名称
 * @returns {string} - 千克重量
 */
export function convertWeightToKg(weight, unitName) {
    const value = parseFloat(weight) || 0;
    
    if (isKilogram(unitName)) {
        return value.toFixed(3);
    }
    
    if (isJin(unitName)) {
        return (value / 2).toFixed(3);
    }
    
    if (isGram(unitName)) {
        return (value / 1000).toFixed(3);
    }
    
    if (isLiang(unitName)) {
        return (value / 20).toFixed(3);
    }
    
    return value.toFixed(3);
}

/**
 * 判断是否为千克单位
 */
function isKilogram(unitName) {
    return unitName === '千克' || unitName === 'kg' || unitName === 'KG';
}

/**
 * 判断是否为斤单位
 */
function isJin(unitName) {
    return unitName === '斤';
}

/**
 * 判断是否为克单位
 */
function isGram(unitName) {
    return unitName === '克' || unitName === 'g' || unitName === 'G';
}

/**
 * 判断是否为两单位
 */
function isLiang(unitName) {
    return unitName === '两';
}

/**
 * 获取单位类型ID
 * @param {string} unitName - 单位名称
 * @returns {number} - 单位ID
 */
export function getUnitId(unitName) {
    const unitMap = {
        '千克': 1,
        'kg': 1,
        'KG': 1,
        '斤': 2,
        '克': 3,
        'g': 3,
        'G': 3,
        '两': 4
    };
    return unitMap[unitName] || 1;
}

/**
 * 获取单位显示名称
 * @param {number} unitId - 单位ID
 * @returns {string} - 单位名称
 */
export function getUnitName(unitId) {
    const unitMap = {
        1: '千克',
        2: '斤',
        3: '克',
        4: '两'
    };
    return unitMap[unitId] || '千克';
}

/**
 * 价格单位换算 - 转换为每千克价格
 * @param {number} price - 原价格
 * @param {string} unitName - 价格单位
 * @returns {number} - 每千克价格
 */
export function convertPriceToKg(price, unitName) {
    const value = parseFloat(price) || 0;
    
    if (isKilogram(unitName)) {
        return value;
    }
    
    if (isJin(unitName)) {
        return value * 2;
    }
    
    if (isGram(unitName)) {
        return value * 1000;
    }
    
    if (isLiang(unitName)) {
        return value * 20;
    }
    
    return value;
}


// WEBPACK FOOTER //
// ./src/utils/weightHelper.js